/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
export const ListConvertionProducts = [
    {
        name: 'Onduladeiras',
        id: 1,
        products: [
            {
                id: 1,
                name: 'Facas de Carbeto',
                img: require('../../assets/images/convertion/TCKnife.png')
                    .default,
            },
            {
                id: 2,
                name: 'Rebolos',
                img: require('../../assets/images/convertion/gw.png').default,
            },
            {
                id: 3,
                name: 'Lonas',
                img: require('../../assets/images/convertion/belt.png').default,
            },
            {
                id: 4,
                name: 'Facões',
                img: require('../../assets/images/convertion/straightKnife.png')
                    .default,
            },
            {
                id: 5,
                name: 'Cilindros',
                img: require('../../assets/images/convertion/cilinder.png')
                    .default,
            },
            {
                id: 6,
                name: 'Pente Guia',
                img: require('../../assets/images/convertion/finguerGuide.png')
                    .default,
            },
            {
                id: 7,
                name: 'No Crush',
                img: require('../../assets/images/convertion/noCrush.png')
                    .default,
            },
            {
                id: 8,
                name: 'Apalpadores',
                img: require('../../assets/images/convertion/wireControl.png')
                    .default,
            },
            {
                id: 9,
                name: 'Wick de Lubrificação',
                img: require('../../assets/images/convertion/wick.png').default,
            },
        ],
    },
    {
        name: 'Impressoras',
        id: 2,
        products: [
            {
                id: 1,
                name: 'Facas',
                img: require('../../assets/images/convertion/printerKnife.png')
                    .default,
            },
            {
                id: 2,
                name: 'Lâminas Raspadoras',
                img: require('../../assets/images/convertion/printerScraper.png')
                    .default,
            },
            {
                id: 3,
                name: 'Mantas',
                img: require('../../assets/images/convertion/anvilCover.png')
                    .default,
            },
            {
                id: 4,
                name: 'Alimentadores',
                img: require('../../assets/images/convertion/printerFeeder.png')
                    .default,
            },
        ],
    },
    {
        name: 'Conversão Tissue',
        id: 3,
        products: [
            {
                id: 1,
                name: 'Disco Orbital',
                img: require('../../assets/images/convertion/logSaw.png')
                    .default,
            },
            {
                id: 2,
                name: 'Rebolos',
                img: require('../../assets/images/convertion/tissueGW.png')
                    .default,
            },
            {
                id: 3,
                name: 'Facas Retas',
                img: require('../../assets/images/convertion/tissueKnives.png')
                    .default,
            },
            {
                id: 4,
                name: 'Facas Rebobinadeira',
                img: require('../../assets/images/convertion/circularKnife.png')
                    .default,
            },
            {
                id: 5,
                name: 'Sobressalentes',
                img: require('../../assets/images/convertion/spareParts.png')
                    .default,
            },
        ],
    },
    {
        name: 'Plotter',
        id: 4,
        products: [
            {
                id: 1,
                name: 'Facas',
                img: require('../../assets/images/convertion/plotterKnife.png')
                    .default,
            },
            {
                id: 2,
                name: 'Feltos',
                img: require('../../assets/images/convertion/felt.png').default,
            },
        ],
    },
    {
        name: 'Embalagem',
        id: 5,
        products: [
            {
                id: 1,
                name: 'Transporte',
                img: require('../../assets/images/convertion/esteira.png')
                    .default,
            },
            {
                id: 2,
                name: 'Paletização e Embalagem',
                img: require('../../assets/images/convertion/pallet.png')
                    .default,
            },
            {
                id: 3,
                name: 'Manuseio de Rolos',
                img: require('../../assets/images/convertion/rolos.png')
                    .default,
            },
        ],
    },
];
